module.exports = __webpack_public_path__ + "static/media/gray-laptop.da627b91.jpg";